module.exports = __webpack_public_path__ + "media/images/icons/chevron-left-solid-310de47df4de719b64e0782654db62dc.svg";